import axios from './axios'
import Cookie from 'js-cookie'

const CLICK_TRIGGER_COOKIE = 'addiesaas_promotion_click_trigger'

axios.interceptors.request.use(request => {
    const url = new URL(request.url)

    if (url.pathname == '/api/customer/order') {
        const promotions = getClickTriggerCookie()
        if (promotions.length) {
            request.headers.common['X-Promotion-Click-Trigger'] = JSON.stringify(promotions)
        }
    }

    return request
})

function getClickTriggerCookie() {
    const cookie = Cookie.get(CLICK_TRIGGER_COOKIE)
    if (typeof cookie !== 'undefined') {
        return JSON.parse(Cookie.get(CLICK_TRIGGER_COOKIE)) || []
    }
    return []
}

function setClickTriggerCookie(promotions) {
    Cookie.set(CLICK_TRIGGER_COOKIE, JSON.stringify(promotions), { expires: 30 })
}

function clearClickTriggerCookie() {
    Cookie.remove(CLICK_TRIGGER_COOKIE)
}

function setClickTrigger(promotionId) {
    let promotions = getClickTriggerCookie()
    if (!promotions.includes(promotionId)) {
        promotions.push(promotionId)
        setClickTriggerCookie(promotions)
    }
}

function getPromotionId() {
    const params = new URLSearchParams(window.location.search)
    return params.get('trigger_promotion_id')
}

async function recordClickTrigger(promotionId) {
    await axios.post(`${window.addiesaas.config.apiUri}/customer/user/promotion/${promotionId}/click-trigger/track`)
}

async function authUserWatcher(authUser, promotions) {
    if (authUser) {
        for (const promotionId of promotions) {
            await recordClickTrigger(promotionId)
        }

        clearClickTriggerCookie()
    }
}

async function checkPromotionUrl(promotionId) {
    const { data } = await axios.post(`${window.addiesaas.config.apiUri}/customer/user/promotion/${promotionId}/click-trigger/check`, {
        url: window.location.href,
    })
    return data
}

export async function beforeReady() {
    const promotionId = getPromotionId()
    if (promotionId) {
        if (await checkPromotionUrl(promotionId)) {
            if (window.addiesaas.store.getters['authUser']) {
                recordClickTrigger(promotionId)
            } else {
                setClickTrigger(promotionId)
            }
        }
    }

    const promotions = getClickTriggerCookie()
    if (promotions.length) {
        window.addiesaas.store.watch(
            (state, getters) => getters['authUser'],
            (authUser) => authUserWatcher(authUser, promotions)
        )
    }
}
